import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithLogout } from "@/lib/baseQuery";
import { Receipt } from "./pos.type";

export const ReceiptApi = createApi({
  reducerPath: "receiptApi",
  tagTypes: ["receipt"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    getReceipt: build.query<Receipt, { orderUuid: string }>({
      query: ({ orderUuid }) => ({
        url: `orders/${orderUuid}/receipt`,
        method: "GET",
        params: { format: "json" },
      }),
      providesTags: ["receipt"],
    }),

    getReceiptHtml: build.query<string, { orderUuid: string }>({
      query: ({ orderUuid }) => ({
        url: `orders/${orderUuid}/receipt`,
        method: "GET",
        params: { format: "html" },
        responseHandler: "text",
      }),
      providesTags: ["receipt"],
    }),

    getReceiptThermal: build.query<Blob, { orderUuid: string }>({
      query: ({ orderUuid }) => ({
        url: `orders/${orderUuid}/receipt`,
        method: "GET",
        params: { format: "thermal" },
        responseHandler: async (response: Response) => {
          return await response.blob();
        },
      }),
      providesTags: ["receipt"],
    }),

    getReceiptPdf: build.query<Blob, { orderUuid: string }>({
      query: ({ orderUuid }) => ({
        url: `orders/${orderUuid}/receipt`,
        method: "GET",
        params: { format: "pdf" },
        responseHandler: async (response: Response) => {
          return await response.blob();
        },
      }),
      providesTags: ["receipt"],
    }),

    sendReceipt: build.mutation<void, { orderUuid: string }>({
      query: ({ orderUuid }) => ({
        url: `orders/${orderUuid}/receipt/send`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetReceiptQuery,
  useGetReceiptHtmlQuery,
  useGetReceiptThermalQuery,
  useGetReceiptPdfQuery,
  useLazyGetReceiptQuery,
  useLazyGetReceiptHtmlQuery,
  useLazyGetReceiptThermalQuery,
  useLazyGetReceiptPdfQuery,
  useSendReceiptMutation,
} = ReceiptApi;
